
const login = r => require.ensure([], () => r(require('baseapp/views/login/login')), 'login')
const about = r => require.ensure([], () => r(require('baseapp/views/self/about')), 'about')
const userCenter = r => require.ensure([], () => r(require('baseapp/views/self/center/userCenter')), 'userCenter')
const userInfo = r => require.ensure([], () => r(require('baseapp/views/self/center/userInfo')), 'userInfo')
const modifyPassword = r => require.ensure([], () => r(require('baseapp/views/self/center/modifyPassword')), 'modifyPassword')
const modifyMobile = r => require.ensure([], () => r(require('baseapp/views/self/center/modifyMobile')), 'modifyMobile')
const sysMessages = r => require.ensure([], () => r(require('baseapp/views/messages/sysMessages')), 'sysMessages')
const msgDetail = r => require.ensure([], () => r(require('baseapp/views/messages/msgDetail')), 'msgDetail')
const bindMobile = r => require.ensure([], () => r(require('baseapp/views/self/bindMobile')), 'bindMobile')

const certifyCenter = r => require.ensure([], () => r(require('baseapp/views/certify/certifyCenter')), 'certifyCenter')

const manageStaff = r => require.ensure([], () => r(require('baseapp/views/self/ManageStaffPage')), 'manageStaff')
const manageShop = r => require.ensure([], () => r(require('baseapp/views/self/ManageShopPage')), 'manageShop')
const manageCustom = r => require.ensure([], () => r(require('baseapp/views/self/ManageCustomPage')), 'manageCustom')
const manageStore = r => require.ensure([], () => r(require('baseapp/views/self/ManageStorePage')), 'manageStore')
const manageBuyer = r => require.ensure([], () => r(require('baseapp/views/self/ManageBuyerPage')), 'manageBuyer')
const company = r => require.ensure([], () => r(require('baseapp/views/self/CompanyPage')), 'company')
const shop = r => require.ensure([], () => r(require('baseapp/views/self/ShopPage')), 'shop')
const bindShop = r => require.ensure([], () => r(require('baseapp/views/self/bindShop')), 'bindShop')
const manageSkuGroup = r => require.ensure([], () => r(require('baseapp/views/self/ManageSkuGroupPage')), 'manageSkuGroup')
const notifySettings = r => require.ensure([], () => r(require('baseapp/views/self/NotifySettingsPage')), 'notifySettings')
const manageApproval = r => require.ensure([], () => r(require('baseapp/views/self/manageApproval')), 'manageApproval')

const supplierSpuList = r => require.ensure([], () => r(require('baseapp/views/supplier/supplierSpuList')), 'supplierSpuList')
const supplierManage = r => require.ensure([], () => r(require('baseapp/views/supplier/supplierManage')), 'supplierManage')
const buyerSku = r => require.ensure([], () => r(require('baseapp/views/supplier/buyerSku')), 'buyerSku')
const editSupplier = r => require.ensure([], () => r(require('baseapp/views/supplier/editSupplier')), 'editSupplier')
const batchOrder = r => require.ensure([], () => r(require('baseapp/views/order/batchOrder')), 'batchOrder')
const addCompany = r => require.ensure([], () => r(require('baseapp/views/company/addCompany')), 'addCompany')
const companyDetails = r => require.ensure([], () => r(require('baseapp/views/company/companyDetails')), 'companyDetails')
const joinCompany = r => require.ensure([], () => r(require('baseapp/views/company/joinCompany')), 'joinCompany')

const buyOrderList = r => require.ensure([], () => r(require('baseapp/views/order/buyOrderList')), 'buyOrderList')
const manageCustomCategory = r => require.ensure([], () => r(require('baseapp/views/self/ManageCustomCategoryPage')), 'ManageCustomCategoryPage')
const searchSupplier = r => require.ensure([], () => r(require('baseapp/views/supplier/searchSupplier')), 'searchSupplier')
const buyerApplyOrderList = r => require.ensure([], () => r(require('baseapp/views/self/buyerApplyOrderList')), 'buyerApplyOrderList')
const applicationDetail = r => require.ensure([], () => r(require('baseapp/views/self/applicationDetail')), 'applicationDetail')
const auditCustomPage = r => require.ensure([], () => r(require('baseapp/views/custom/NotAuditCustomPage')), 'NotAuditCustomPage')
const mergeCustomPage = r => require.ensure([], () => require('baseapp/views/custom/mergeCustomPage'), 'mergeCustomPage')
export default {
  routes: [
    {
      path: '/login',
      component: login
    },
    {
      path: '/about',
      component: about
    },
    {
      path: '/usercenter',
      component: userCenter,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/userinfo',
      component: userInfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/modifypassword',
      component: modifyPassword,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/modifymobile',
      component: modifyMobile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sysmessages',
      component: sysMessages,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/msgdetail/:msgid',
      component: msgDetail,
      props: (route) => ({msgid: Number(route.params.msgid)}),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bindmobile',
      component: bindMobile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/certifycenter/',
      component: certifyCenter,
      meta: {
        requiresAuth: true
      }
    },
    { path: '/manageStaff', component: manageStaff, meta: { requiresAuth: true } },
    { path: '/manageShop', component: manageShop, meta: { requiresAuth: true } },
    { path: '/manageCustom', component: manageCustom, meta: { requiresAuth: true } },
    { path: '/manageStore', component: manageStore, meta: { requiresAuth: true } },
    { path: '/manageBuyer', component: manageBuyer, meta: { requiresAuth: true } },
    { path: '/supplierSpuList', component: supplierSpuList, meta: { requiresAuth: true } },
    { path: '/manageSkuGroup', component: manageSkuGroup, meta: {requiresAuth: true} },
    { path: '/notifySettings', component: notifySettings, meta: {requiresAuth: true} },
    { path: '/manageApproval', component: manageApproval, meta: {requiresAuth: true} },
    { path: '/manageCustomCategory', component: manageCustomCategory, meta: {requiresAuth: true} },

    // test pages
    { path: '/test/TestMultiChoice',
      component: r => require.ensure([], () => r(require('baseapp/testviews/TestMultiChoice')), 'TestMultiChoice'),
      meta: { requiresAuth: true } },
    { path: '/test/TestDialog',
      component: r => require.ensure([], () => r(require('baseapp/testviews/TestDialog')), 'TestDialog'),
      meta: { requiresAuth: true } },
    { path: '/test/TestTableSelect',
      component: r => require.ensure([], () => r(require('baseapp/testviews/TestTableSelectPage')), 'TestTableSelect'),
      meta: { requiresAuth: true } },

    { path: '/company/:companyid',
      component: company,
      props: (route) => ({pCompanyid: Number(route.params.companyid)}),
      meta: {
        requiresAuth: true
      } },
    { path: '/shop/:shopid',
      component: shop,
      props: (route) => ({shopid: Number(route.params.shopid)}),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bindshop',
      component: bindShop,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/suppliermanage',
      component: supplierManage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/editsupplier/:supplierid?',
      component: editSupplier,
      props: (route) => ({pSupplierid: Number(route.params.supplierid) || 0}),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/batchorder',
      component: batchOrder,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/buyerSku/:customid/:skuid?',
      props: (route) => ({pSkuid: Number(route.params.skuid) || 0, pCustomid: Number(route.params.customid) || 0}),
      component: buyerSku,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/addCompany/:change?',
      props: (route) => ({isChange: Boolean(route.params.change)}),
      component: addCompany,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/companyDetails/:companyid/:change?',
      props: (route) => ({pCompanyid: Number(route.params.companyid) || 0, isChange: Boolean(route.params.change)}),
      component: companyDetails,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/joinCompany/:change?',
      props: (route) => ({isChange: Boolean(route.params.change)}),
      component: joinCompany,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/buyOrderList/:chargeType?',
      props: (route) => ({pChargeType: route.params.chargeType}),
      component: buyOrderList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/searchSupplier/:pCustomid?',
      props: (route) => ({pCustomid: Number(route.params.pCustomid)}),
      component: searchSupplier,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/buyerApplyOrderList',
      component: buyerApplyOrderList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/applicationDetail/:pTaskid',
      props: (route) => ({pTaskid: Number(route.params.pTaskid)}),
      component: applicationDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/auditCustomPage',
      component: auditCustomPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/mergeCustomPage/:pCustomid/:pCustomCompanyid',
      props: (route) => ({pCustomid: Number(route.params.pCustomid), pCustomCompanyid: Number(route.params.pCustomCompanyid)}),
      component: mergeCustomPage,
      meta: {
        requiresAuth: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/router/router.js